module.exports = __webpack_public_path__ + "assets/img/scss_vue_config.72492209.jpg";